module.exports = __webpack_public_path__ + "img-dashboard/register/web-cv-yogyakarta.8e238440.png";